import React from 'react'
import moment from 'moment'
import { joinValues, themeNumber, pairTitle, pairTime } from './buildWeek'
import styles from './styles.module.css'

/* Таблица расписания за неделю. Строка — одна пара дня, ячейка дня объединена
   по вертикали на все пары дня. Порядок строк задаёт сервер: дата, номер пары,
   учебная группа — здесь он только сохраняется, сортировки по щелчку в шапке
   в режиме нет (п. 3.11 ТЗ). */

const Cell = ({ value, className }) => (
  <td className={className}>
    {value ? value : <span className={styles.dash}>—</span>}
  </td>
)

const ScheduleTable = ({ days, today, onOpenPair }) => (
  <table className={styles.table}>
    <thead>
      <tr>
        <th className={styles.colDay}>День недели</th>
        <th className={styles.colPair}>Занятие</th>
        <th>Дисциплина</th>
        <th className={styles.colGrp}>Группа</th>
        <th className={styles.colRoom}>Аудитория</th>
        <th className={styles.colKind}>Вид занятия</th>
        <th className={styles.colTheme}>Номер темы/занятия</th>
      </tr>
    </thead>
    <tbody>
      {days.map(day => day.pairs.map((pair, index) => {
        const isToday = day.date === today
        const rowClass = [
          isToday ? styles.today : '',
          index === day.pairs.length - 1 ? styles.dayEnd : '',
        ].filter(Boolean).join(' ')

        return (
          <tr key={pair.key} className={rowClass} onClick={() => onOpenPair(pair)}>
            {!index && (
              <td className={styles.day} rowSpan={day.pairs.length}>
                <div className={styles.dayName}>{day.weekdayName}</div>
                <div className={styles.dayDate}>
                  {moment(day.date, 'YYYY-MM-DD').format('DD.MM.YYYY')}
                </div>
                {isToday && <div className={styles.todayMark}>сегодня</div>}
              </td>
            )}
            <td>
              <div className={styles.pairName}>{pairTitle(pair)}</div>
              {pairTime(pair) && <div className={styles.pairTime}>{pairTime(pair)}</div>}
            </td>
            <Cell
              className={styles.discipline}
              value={joinValues(pair.lessons, lesson => lesson.course_name)}
            />
            <Cell
              className={styles.num}
              value={joinValues(pair.lessons, lesson => lesson.group_name)}
            />
            <Cell
              className={styles.num}
              value={joinValues(pair.lessons, lesson => lesson.room_names || lesson.room_name)}
            />
            <Cell value={joinValues(pair.lessons, lesson => lesson.lesson_type_name)} />
            <Cell className={styles.num} value={joinValues(pair.lessons, themeNumber)} />
          </tr>
        )
      }))}
    </tbody>
  </table>
)

export default ScheduleTable
